import breakpointTokens from '@lmig/lmds-tokens/dist/json/core/breakpoint.json';
export function getWindowWidth() {
  const { innerWidth: width } = window;
  return width;
}

export function isSmallMobileView() {
  //width <= 479
  return getWindowWidth() <= parseInt(breakpointTokens.lmig.breakpoint.base.max);
}

export function isMobileView() {
  //width <= 768
  return getWindowWidth() <= parseInt(breakpointTokens.lmig.breakpoint.md.min);
}

export function isTabletView() {
  //width <= 960 && width > 768
  return (
    getWindowWidth() <= parseInt(breakpointTokens.lmig.breakpoint.lg.min) &&
    getWindowWidth() > parseInt(breakpointTokens.lmig.breakpoint.md.min)
  );
}

export function isDesktopView() {
  //width > 960
  return getWindowWidth() > parseInt(breakpointTokens.lmig.breakpoint.lg.min);
}
